import { Button, Row, Col } from "react-bootstrap";
import UsersLineChart from "../../components/micheal/CompanyReport/UsersLineChart";
import PaymentDonutChart from "../../components/micheal/CompanyReport/PaymentDonutChart";
import CompanyTable from "../../components/micheal/CompanyReport/CompanyTable";

export default function CompanyReport() {

  const usersChartData = [
    { month: "Jan", active: 25000, inactive: 12000 },
    { month: "Feb", active: 35000, inactive: 15000 },
    { month: "Mar", active: 40000, inactive: 18000 },
    { month: "Apr", active: 18000, inactive: 10000 },
    { month: "May", active: 28000, inactive: 14000 },
    { month: "Jun", active: 50000, inactive: 22000 },
    { month: "Jul", active: 30000, inactive: 15000 },
    { month: "Aug", active: 15000, inactive: 8000 },
    { month: "Sep", active: 45000, inactive: 20000 },
    { month: "Oct", active: 30000, inactive: 16000 },
    { month: "Nov", active: 38000, inactive: 17000 },
    { month: "Dec", active: 32000, inactive: 15000 },
  ];

  const paymentData = [
    { name: "Campaigns", value: 44 },
    { name: "Google", value: 55 },
    { name: "Paid Social", value: 17 },
    { name: "Referrals", value: 41 },
  ];

  const companyTableData = [
    {
      id: 1,
      name: "Antony Lewis",
      role: "Web Designer",
      email: "antony@example.com",
      status: "Active",
      avatar: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: 2,
      name: "Sophia Miller",
      role: "UI Designer",
      email: "sophia@example.com",
      status: "Active",
      avatar: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: 3,
      name: "James Anderson",
      role: "Frontend Developer",
      email: "james@example.com",
      status: "Inactive",
      avatar: "https://i.pravatar.cc/40?img=3",
    },
    {
      id: 4,
      name: "Olivia Brown",
      role: "Project Manager",
      email: "olivia@example.com",
      status: "Active",
      avatar: "https://i.pravatar.cc/40?img=4",
    },
    {
      id: 5,
      name: "Liam Wilson",
      role: "Backend Developer",
      email: "liam@example.com",
      status: "Inactive",
      avatar: "https://i.pravatar.cc/40?img=5",
    },
    {
      id: 6,
      name: "Emma Davis",
      role: "HR Manager",
      email: "emma@example.com",
      status: "Active",
      avatar: "https://i.pravatar.cc/40?img=6",
    },
  ];

  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="d-flex mb-3">
        <h4>Company Reports</h4>
        <Button className="ms-auto" size="sm" variant="dark">
          Export
        </Button>
      </div>

      {/* CHARTS */}
      <Row className="mb-3">
        <Col md={6}>
          <UsersLineChart data={usersChartData} />
        </Col>

        <Col md={6}>
          <PaymentDonutChart data={paymentData} />
        </Col>
      </Row>

      {/* TABLE */}
      <CompanyTable data={companyTableData} />

    </div>
  );
}